import { Injectable } from '@angular/core';
import { AnyType } from '@thehubz/shared/model';
import { ContentChange } from 'ngx-quill';

@Injectable()
export class Editor2UtilService {
  private static WhitespaceRegex = /\s+/gi;

  /**
   * Find the delete tagged user
   * @param event
   * @returns
   */
  findRemovedMention(event: ContentChange) {
    const newContent = this.removeMentionDuplicates(
      event.content.ops.filter((ops: AnyType) => ops.insert.mention),
      'id',
    );
    const oldContent = this.removeMentionDuplicates(
      event.oldDelta.ops.filter((ops: AnyType) => ops.insert.mention),
      'id',
    );
    return oldContent.find(
      (oldC: AnyType) => !newContent.some((newC: AnyType) => newC.insert.mention.id === oldC.insert.mention.id),
    );
  }

  /**
   * Remove duplicates from the list
   * @param list
   * @returns
   */
  removeListDuplicate(list: string[]) {
    return Array.from(new Set(list)).map((user) => JSON.parse(user));
  }

  /**
   * Count string words
   * @param value
   * @returns
   */
  truncateWord(value: string, maxWords: number) {
    const cleanText = value.trim().replace(Editor2UtilService.WhitespaceRegex, ' ');
    // just a wild guess that the text length will contain that many words. But won't trigger logic for short text
    if (cleanText.length > 250) {
      const splitWord = cleanText.split(' ');
      if (splitWord.length > maxWords) {
        return splitWord.splice(0, maxWords).join(' ') + (splitWord.length > maxWords ? '...' : '');
      }
    }
    return cleanText;
  }

  /**
   * remove duplicates in mention object
   * @param myArray
   * @param prop
   * @returns
   */
  private removeMentionDuplicates(myArray: AnyType, prop: string) {
    return myArray.filter((obj: AnyType, pos: number, arr: AnyType) => {
      return arr.map((mapObj: AnyType) => mapObj.insert.mention[prop]).indexOf(obj.insert.mention[prop]) === pos;
    });
  }
}
